import { required, maxLength } from 'react-admin';
import { dataProvider } from '../dataProvider';
import {getSelectedCompanyFilterValue} from "../helper/filter";

const validateUniqueField = (
    fieldName,
    errorMessage = 'This value is already in the database.',
    resource = 'courses'
) => {
    return async (value, allValues) => {
        if (!value) return undefined;

        const filter = {
            [fieldName]: value,
            company: allValues?.company?.id || allValues?.company || getSelectedCompanyFilterValue(),
        };

        const recordId = record => String(record?.originId ?? record?.id ?? record?.['@id'] ?? '').split('/').pop();
        const currentId = recordId(allValues);

        try {
            const { data } = await dataProvider.getList(resource, {
                filter,
                pagination: { page: 1, perPage: 100 },
                sort: { field: 'id', order: 'ASC' },
            });
            const duplicates = data.filter(item => recordId(item) !== currentId);

            if (duplicates.length > 0) {
                return errorMessage;
            }

            return undefined;
        } catch (error) {
            return `Error while checking uniqueness for ${fieldName}.`;
        }
    };
};

export const validateCompany = [required()];

export const validateSeoTitle = [
    required('SEO title is required'),
    maxLength(180, 'Maximum length is 180 characters.'),
    validateUniqueField('translations.seoTitle', 'This SEO title is already in the database.'),
];

export const validateSeoDescription = [
    required('SEO description is required'),
    maxLength(300, 'Maximum length is 300 characters.'),
    validateUniqueField('translations.seoDescription', 'This SEO description is already in the database.'),
];

export const validateKeywords = [
    maxLength(512, 'Maximum length is 512 characters.'),
];

export const validateSeoKeywords = [
    required('SEO keywords are required'),
    maxLength(512, 'Maximum length is 512 characters.'),
];